import { createAction, props } from '@ngrx/store';
import { DefaultLookupResponse } from '../../models/core-apis/default-lookup.interfaces';

enum DefaultLookupActionTypes {
  storeDefaultLookupInputValues = '[flight-shop book widget] default lookup store input values',
  loadDefaultLookupLanding = '[flight-shop book widget] load default lookup landing',
  loadDefaultLookupLandingSuccess = '[flight-shop book widget] load default lookup landing success',
  loadDefaultLookupLandingFailure = '[flight-shop book widget] load default lookup landing failure'
}

export const LoadDefaultLookupLanding = createAction(
  DefaultLookupActionTypes.loadDefaultLookupLanding
);

export const LoadDefaultLookupLandingSuccess = createAction(
  DefaultLookupActionTypes.loadDefaultLookupLandingSuccess,
  props<{ defaultLookupLandingData: DefaultLookupResponse }>()
);

export const LoadDefaultLookupLandingFailure = createAction(
  DefaultLookupActionTypes.loadDefaultLookupLandingFailure
);

export const StoreDefaultLookupInputValues = createAction(
  DefaultLookupActionTypes.storeDefaultLookupInputValues,
  props<{
    triggerDefaultsLookupLanding: boolean;
    cacheKeySuffix: string;
    defaultLookupResponse: DefaultLookupResponse | null;
  }>()
);
